<app-data-table mainTitle="Relacionar Participante"
            singleTitle="Relacionar Participante"
            routerPath="/cad-participante-relac"
            entityPath="/cadparticipanterelac"
            keyField="id"
            [entity]="cadParticipanteRelac"
            [columns]="this['columns']"
            [controls]="this['controls']">
</app-data-table>
